export const PayBridges = {
  en: {
    'PayBridge Tokens': 'PayBridge tokens',
    'Create PayBridge Token': 'Create PayBridge token',
    Company: 'Company',
    Location: 'Location',
    Notes: 'Notes',
    Online: 'Online',
    Created: 'Created',
    'Last connection': 'Last connection',
    Terminals: 'Terminals',
  },
  uk: {
    'PayBridge Tokens': 'PayBridge токени',
    'Create PayBridge Token': 'Створити PayBridge токен',
    Company: 'Компанія',
    Location: 'Локація',
    Notes: 'Нотатки',
    Online: 'Онлайн',
    Created: 'Створено',
    'Last connection': 'Останнє підключення',
    Terminals: 'Термінали',
  },
};

export const PayBridgeForm = {
  en: {
    ...PayBridges.en,
    'PayBridge Token': 'PayBridge token',
    'New PayBridge Token': 'New PayBridge token',
    'Edit PayBridge Token': 'Edit PayBridge token',
    'Update PayBridge Token': 'Update PayBridge token',
    'Cashier Terminals': 'Cashier terminals',
    'MAC Address': 'MAC address',
    'Auth Token': 'Auth token',
    'Regenerate Token': 'Regenerate token',
    'Auth Token Created': 'Auth token created',
    'Copy this token now. It will not be shown again.':
      'Copy this token now. It will not be shown again.',
    'Successfully copied': 'Successfully copied',
    'Close and go to list': 'Close and go to list',
  },
  uk: {
    ...PayBridges.uk,
    'PayBridge Token': 'PayBridge токен',
    'New PayBridge Token': 'Новий PayBridge токен',
    'Edit PayBridge Token': 'Редагування PayBridge токена',
    'Update PayBridge Token': 'Оновити PayBridge токен',
    'Cashier Terminals': 'Касові термінали',
    'MAC Address': 'MAC адреса',
    'Auth Token': 'Токен авторизації',
    'Regenerate Token': 'Перегенерувати токен',
    'Auth Token Created': 'Токен авторизації створено',
    'Copy this token now. It will not be shown again.':
      'Скопіюйте цей токен зараз. Він більше не буде показаний.',
    'Successfully copied': 'Успішно скопійовано',
    'Close and go to list': 'Закрити та перейти до списку',
  },
};
